// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g06e","buttons":"styles_buttons__19YBm"};